export interface Conversation {
  id: string | number;
  name?: string;
  createdAt: string;
}

export enum ChatMessageRole {
  User = 'user',
  Assistant = 'assistant',
}

export interface ChatMessage {
  id: string | number;
  role: ChatMessageRole;
  text: string;
  timestamp: Date;
  isWarningMessage?: boolean;
  errorCode?: string | null;
  isLoading?: boolean;
}

/** Vision AI message shape from `visionAiMessagesStore`. */
export interface VisionAiStoreMessage {
  id: string | number;
  sender: string;
  message?: string | null;
  createdAt: string;
  intentType?: string;
  errorCode?: number | string | null;
  isWarningMessage?: boolean;
  conversationId: string | number | null;
}
